<template>
  <Dialog :show.sync="visible" width="500px" title="指标">
    <template v-slot:body>
      <div class="dialog-body">
        <el-table :data="tableData">
          <el-table-column type="index" width="50" align="center" label="序号"/>
          <el-table-column prop="label" label="指标名称"/>
          <el-table-column prop="value" label="指标值"/>
        </el-table>
      </div>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('cancel_k') }}</el-button>
      <el-button size="small" type="primary" @click="visible = false">{{ $t('confirm_k') }}</el-button>
    </div>
  </Dialog>
</template>
<script>
import {toFixed} from "@/utils/input"

export default {
  inject: {
    getCode: {
      default: () => {
      }
    }
  },
  data() {
    return {
      visible: false,
      selectGroup: {},
      code: null
    }
  },
  computed: {
    list() {
      if (this.code === 15) {
        return [
          {label: `有效值`, prop: 'RmsValue'},
          {label: `峰值`, prop: 'IndexP'},
          {label: `峰峰值`, prop: 'IndexPP'},
        ]
      } else {
        return [
          {label: `峰值`, prop: 'IndexP'},
          {label: `平均值`, prop: 'IndexMean'},
          {label: `峰峰值`, prop: 'IndexPP'},
          {label: `有效值`, prop: 'RmsValue'},
          {label: '峭度指标', prop: 'IndexKur'},
          {label: '波形指标', prop: 'IndexK'},
          {label: '峰值指标', prop: 'IndexC'},
          {label: '脉冲指标', prop: 'IndexI'},
          {label: '裕度指标', prop: 'IndexL'},
        ]
      }
    },
    tableData() {
      return this.list.map(item => {
        let value = this.selectGroup[item.prop]
        if (item.prop === 'IndexKur') value += 3
        else if (item.prop === 'IndexMean' && value < 0) value = 0
        return {
          ...item,
          value: toFixed(value),
        }
      })
    },
  },
  methods: {
    open(selectGroup, unit) {
      this.code = this.getCode()
      this.visible = true
      this.codeUnit = unit
      this.selectGroup = selectGroup
    },
  }
}
</script>
